import { render, staticRenderFns } from "./dashboard-info.vue?vue&type=template&id=5347e839&scoped=true"
import script from "./dashboard-info.vue?vue&type=script&lang=js"
export * from "./dashboard-info.vue?vue&type=script&lang=js"
import style0 from "./dashboard-info.vue?vue&type=style&index=0&id=5347e839&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347e839",
  null
  
)

export default component.exports